import { ABaseModel } from '../abstracts/ABaseModel.js';
import { ICache, ICachePaginationResult } from '../interfaces/Cache.js';
import { PaginationResult } from './List.js';

/**
 * Cache
 */
class Cache extends ABaseModel implements ICache {
  id: string;
  name: string;
  description: string;
  tags: Array<string>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * CachePaginationResult
 */
class CachePaginationResult extends PaginationResult implements ICachePaginationResult {
  declare items: Array<Cache>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

export { Cache, CachePaginationResult };
